import $ from 'jquery';
import Share from 'ninelines-sharing';

$('[data-social]').on('click.share', (e) => {
	const $socialBtn = $(e.currentTarget);
	const social = $socialBtn.data('social');
	let url = 'https://incrussia.ru/wp-content/special-projects/2020/beeline/result?r=' + $('.beeline-test').attr('data-result');
	// console.log(url);
	$socialBtn.get(0).blur();

	Share[social](url);
});
